import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TauxReconnaissance } from 'src/app/shared/models/tauxReconnaissance';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class TauxReconnaissanceService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllTauxReconnaissance(): Observable<TauxReconnaissance[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.tauxReconnaissanceUrl}/all`,
			'getAllTauxReconnaissance'
		);
	}

	importTauxReconnaissance(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'tauxReconnaissance.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.tauxReconnaissanceUrl}/import`,
			`importTauxReconnaissance`,
			formData
		);
	}

	getTauxReconnaissanceById(id: number): Observable<TauxReconnaissance> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.tauxReconnaissanceUrl}/get/${id}`,
			'getTauxReconnaissanceById'
		);
	}

	updateTauxReconnaissance(tauxReconnaissance: TauxReconnaissance): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.tauxReconnaissanceUrl}/update/${tauxReconnaissance.id}`,
			'updateTauxReconnaissance',
			tauxReconnaissance
		);
	}

	addTauxReconnaissance(tauxReconnaissance: TauxReconnaissance): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.tauxReconnaissanceUrl}/add`,
			'addTauxReconnaissance',
			tauxReconnaissance
		);
	}

	deleteTauxReconnaissance(tauxReconnaissanceId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.tauxReconnaissanceUrl}/delete/${tauxReconnaissanceId}`,
			`deleteTauxReconnaissance`
		);
	}
}
